import React, { lazy, Suspense } from 'react'
import PropTypes from 'prop-types'

const Loading = ({ pastDelay }) =>
  pastDelay ? (
    <div style={{ margin: 'auto' }} className="vx_spinner-small" />
  ) : null

Loading.propTypes = {
  pastDelay: PropTypes.bool.isRequired,
}

/**
 * Do not show anything while loading
 * Useful when the loading component does not block user interaction
 */
const SilentLoading = () => null

export default (loader, showLoading = true) => {
  const LazyComponent = lazy(loader)
  const Component = props => (
    <Suspense fallback={showLoading ? <Loading /> : <SilentLoading />}>
      <LazyComponent {...props} />
    </Suspense>
  )
  Component.preload = loader
  return Component
}
